module.exports = require("assert");


//////////////////
// WEBPACK FOOTER
// external "assert"
// module id = 5
// module chunks = 0